import React, { useState } from "react";
import CustomInput from "./CustomInput";
import axios from "axios";
import config from '../../config';
import {
  Grid,
  FormControl,
  Select,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
 
  DialogActions,

} from "@mui/material";

const CustomSelect = ({ label, value, onChange, options, placeholder, error }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [newOption, setNewOption] = useState("");

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setNewOption(""); // Reset input value
  };

  const fetchUpdatedOptions = async () => {
    try {
      const response = await axios.get(`${config.apiBaseUrl}/Categories`);
      if (response.status === 200) {
        const updatedOptions = response.data.map((category) => ({
          value: category.categoryId,
          label: category.name,
        }));
        options.splice(0, options.length, ...updatedOptions); // Cập nhật danh sách options
        onChange(updatedOptions[0]?.value || ""); // Chọn giá trị đầu tiên hoặc để trống
      }
    } catch (error) {
      console.error("Lỗi khi lấy danh mục sau khi thêm:", error);
    }
  };

  const handleSave = async () => {
    try {
      const payload = { name: newOption }; // Tạo payload với giá trị cần truyền
      console.log("📤 Sending payload to API:", payload); // Log payload gửi đi
      const response = await axios.post(
        `${config.apiBaseUrl}/Categories/Add`,
        payload, // Truyền payload vào phương thức post
        { headers: { "Content-Type": "application/json" } } // Sử dụng Content-Type phù hợp
      );
      console.log("📥 API Response:", response.data); // Log phản hồi từ API
      if (response.status === 200 && response.data.categoryId) {
        alert(`✅ Sản phẩm đã được thêm thành công! (ID: ${response.data.categoryId})`);
        const newOptionObj = { value: response.data.categoryId, label: payload.name };
        console.log("📤 Adding new option to dropdown:", newOptionObj);
        options.push(newOptionObj); // Thêm tùy chọn mới vào danh sách
      
        setNewOption(""); // Reset giá trị input
        handleCloseDialog();

        // Gọi lại API để lấy danh sách phân loại mới
        fetchUpdatedOptions();
      } else {
        alert("❌ Có lỗi xảy ra khi thêm sản phẩm.");
      }
    } catch (error) {
      console.error("❌ Lỗi khi gửi yêu cầu:", error);
      if (error.response) {
        console.log("📌 API Error Response:", error.response);
        alert(`❌ Lỗi API: ${error.response.status} - ${error.response.data?.Message || "Không xác định"}`);
      } else {
        alert("❌ Không thể kết nối đến server!");
      }
    }
  };

  return (
    <Grid item xs={12}>
      <FormControl fullWidth error={!!error} sx={{ width: 250 }}>
        <Select
          value={value}
          onChange={onChange}
          displayEmpty
          renderValue={(selected) => {
            const selectedOption = options.find(option => option.value === selected);
            return selectedOption ? selectedOption.label : (placeholder || `Chọn ${label?.toLowerCase()}`);
          }}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
          <MenuItem onClick={handleOpenDialog}>
            <em>Thêm phân loại mới</em>
          </MenuItem>
        </Select>
      </FormControl>

      {/* Dialog để nhập tùy chọn mới */}
      <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="xs">
  <DialogTitle sx={{ fontWeight: 'bold',
  }}>Phân loại mới</DialogTitle>
 
          <CustomInput
            label="Phân Loại mới"
            value={newOption}
            onChange={(e) => setNewOption(e.target.value)}
            sx={{ justifyContent: "space-between" }}
            
          />
  
  <DialogActions sx={{ justifyContent: "space-between" }}>
    <Button
      onClick={handleCloseDialog}
      color="error"
      variant="outlined"
      sx={{ width: "48%" }}
    >
      Hủy
    </Button>
    <Button onClick={handleSave} color="primary" variant="contained" sx={{ width: "48%" }}>
      Thêm
    </Button>
  </DialogActions>
</Dialog>
    </Grid>
  );
};


export default CustomSelect;